import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { IAdminBannerSave, IAdminBannerSaveLanguageEnum, IBannerRO } from 'api'
import { useNavigate } from 'react-router-dom'

export default function BannerEdit() {
  const navigate = useNavigate()
  const id = useQueryValue('id', '')

  const { data, refetch } = useApi({
    id: 'bannerDetail',
    fn: api().adminBanner.adminBannerDetail,
    params: Number(id),
    enabled: !!id,
  })

  const { data: bannerList } = useApi({
    id: 'banner-list',
    fn: api().adminBanner.adminBannerList,
  })

  const onSave = async (formData: IBannerRO) => {
    try {
      // 순서 중복 검사
      const existingBanner = bannerList?.items.find(
        (banner) => banner.order === formData.order && banner.id !== Number(id),
      )

      // if (existingBanner) {
      //   alert('이미 등록된 순서입니다. 다른 순서를 선택해주세요.')
      //   return
      // }

      const saveData: IAdminBannerSave = {
        order: formData.order,
        imageId: formData.image?.id || 0,
        link: formData.link || undefined,
        language: formData.language as unknown as IAdminBannerSaveLanguageEnum,
      }

      if (id) {
        await api().adminBanner.adminBannerUpdate(Number(id), saveData)
      } else {
        const result = await api().adminBanner.adminBannerCreate(saveData)
        navigate(`/banner/edit?id=${result}`, { replace: true })
      }
      refetch()
      navigate('/banner', { replace: true })
    } catch (error) {
      console.error('저장 중 오류 발생:', error)
      alert('저장 중 오류가 발생했습니다.')
    }
  }

  const onDelete = async () => {
    if (id) {
      try {
        await api().adminBanner.adminBannerDelete(Number(id))
        navigate('/banner', { replace: true })
      } catch (error) {
        console.error('삭제 중 오류 발생:', error)
      }
    }
  }

  return (
    <ContentDetailView
      title="배너 수정"
      data={data}
      onSave={onSave}
      onDelete={id ? onDelete : undefined}
      hideSaveToast={() => true}
    >
      <DetailForm
        data={data}
        fields={[
          {
            label: '언어',
            key: 'language',
            type: FormFieldType.SELECT,
            options: [
              { label: '한국어', value: IAdminBannerSaveLanguageEnum.Ko },
              {
                label: '중국어(간체)',
                value: IAdminBannerSaveLanguageEnum.ZhCN,
              },
              {
                label: '중국어(번체)',
                value: IAdminBannerSaveLanguageEnum.ZhTW,
              },
              { label: '일본어', value: IAdminBannerSaveLanguageEnum.Ja },
              { label: '영어', value: IAdminBannerSaveLanguageEnum.En },
              { label: '태국어', value: IAdminBannerSaveLanguageEnum.Th },
            ],
            required: true,
          },
          {
            label: '배너 이미지',
            key: 'image',
            type: FormFieldType.FILE,
            accept: 'image/*',
            required: true,
            async uploadHandler(file) {
              const res = await api().assets.uploadCreate({
                file: file.file,
                crop: JSON.stringify({ ...file.crop, highQuality: true }),
              })
              return res
            },
            imageAlertText: '이미지 권장 사이즈 : 최소 1200*400 / 비율 3:1',
          },
          {
            label: '링크 URL',
            key: 'link',
            type: FormFieldType.STRING,
            placeholder: 'https://example.com',
          },
          {
            label: '순서',
            key: 'order',
            type: FormFieldType.NUMBER,
            required: true,
          },
        ]}
      />
    </ContentDetailView>
  )
}
